
import React, { useState } from "react";
import UploadFileImg from "../../Assets/Images/CommanImages/uploadfile.png";

const QuickFileUpload = ({ label, onFileSelect }) => {
  const [fileName, setFileName] = useState("No file selected");

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];

      // Validate file type (only .docx files are allowed)
      if (file.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
        alert("Invalid file type. Please upload a .docx file.");
        setFileName("No file selected"); // Reset file name
        if (onFileSelect) {
          onFileSelect(null); // Pass null to indicate no valid file was selected
        }
        return;
      }

      setFileName(file.name); // Set valid file name
      if (onFileSelect) {
        onFileSelect(file); // Pass the selected file to the parent component
      }
    }
  };

  const openFileBrowser = () => {
    document.getElementById("file-input").click();
  };

  return (
    <div className="custom-file-input-wrapper">
      <label className="custom-file-label">{label}</label>
      <div className="custom-file-input-container">
        <span className="custom-file-name">{fileName}</span>
        <span className="custom-file-icon" onClick={openFileBrowser}>
          <img src={UploadFileImg} alt="Upload file" />
        </span>
        <input
          type="file"
          id="file-input"
          className="custom-file-input"
          onChange={handleFileChange}
          accept=".docx"
          // accept=".docx,.pdf"
        />
      </div>
    </div>
  );
};

export default QuickFileUpload;
